/*
  WARNING !
  WHEN ADDING STUFF HERE, PLEASE ALSO UPDATE
  data/notifications/aknowledgment
  components/Notifications/Center/item
*/
export const ADD_USER_TO_CHANNEL = 'ADD_USER_TO_CHANNEL'
export const UPDATE_USER_ROLES_ON_CHANNEL = 'UPDATE_USER_ROLES_ON_CHANNEL'
export const ADD_THREAD_TO_NOTE = 'ADD_THREAD_TO_NOTE'
export const MENTION_IN_COMMENT = 'MENTION_IN_COMMENT'
export const MENTION_IN_NOTE = 'MENTION_IN_NOTE'
export const REPLY_TO_COMMENT = 'REPLY_TO_COMMENT'
export const NUDGE_ABOUT_NOTE = 'NUDGE_ABOUT_NOTE'
export const REQUEST_CHANNEL_ACCESS = 'REQUEST_CHANNEL_ACCESS'
export const REQUEST_NOTE_ACCESS = 'REQUEST_NOTE_ACCESS'
/*
  WARNING !
  WHEN ADDING STUFF HERE, PLEASE ALSO UPDATE
  data/notifications/aknowledgment
  components/Notifications/Center/item
*/
